export default "https://cdn-static.gokick.com/assets/be369b33e14920b1856d71de34d484ec78759d8a/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";